module.exports = __webpack_public_path__ + "img/tongy.579bbcfe.png";